export const createAtlasCodeResendIdempotencyKey = () => {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }
  return `atlas-resend-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const operationKey = (workflow, referenceId) => `${workflow}:${referenceId}`;
const storageKey = (workflow, referenceId) => (
  `caddiepay:atlas-code-resend:${operationKey(workflow, referenceId)}`
);

const getSessionStorage = () => {
  try {
    return globalThis.sessionStorage || null;
  } catch (error) {
    return null;
  }
};

export const getOrCreateAtlasCodeResendKey = (store, workflow, referenceId) => {
  const key = operationKey(workflow, referenceId);
  if (!store[key]) {
    const sessionStorage = getSessionStorage();
    store[key] = sessionStorage?.getItem(storageKey(workflow, referenceId))
      || createAtlasCodeResendIdempotencyKey();
    sessionStorage?.setItem(storageKey(workflow, referenceId), store[key]);
  }
  return store[key];
};

export const clearAtlasCodeResendKey = (store, workflow, referenceId) => {
  delete store[operationKey(workflow, referenceId)];
  getSessionStorage()?.removeItem(storageKey(workflow, referenceId));
};
